var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf"},[_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh)"},attrs:{"src":("/static/pdf/web/viewer.html?file=" + (encodeURIComponent(_vm.src))),"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }